export default __webpack_public_path__ + "static/media/zoom-out.467f6d44.svg";